import React from "react";
import styles from "./VoucherImageSquare.module.scss";
import {ICompanyPrediction, IProduct} from 'data/interfaces/products';
import GenericImageSquare from '../genericImageSquare';
import PercentTicket from 'gui/components/icons/PercentTicket';

import {flightCompanyToLogoUrl} from '../airlineImageSquare/AirlineImageSquare';
import {ASSET_TYPE} from 'data/enums/assets';
import {eVoucherTypes} from 'data/enums/products';
import PlaceImageSquare, {isThereAssetList} from "../placeImageSquare/PlaceImageSquare";
import {getPlaceDetailsName, getVoucherName} from "data/redux/selectors/productSelector";

export interface IVoucherImageSquare {
  gui?: any;
  product: Partial<IProduct>;
  className?: any;
  iconContainerClassName?: string;
  children?: any;
}

const voucherTypeToImageClass = (product: Partial<IProduct>) => {
  switch (product.voucherDetails.type) {
    case eVoucherTypes.flightCompanies:
      return styles.VoucherImageSquarePlane;
    case eVoucherTypes.hotels:
      return styles.VoucherImageSquareHotel;
    case eVoucherTypes.cruise:
      return styles.VoucherImageSquareCruise;
    case eVoucherTypes.agencies:
      return styles.VoucherImageSquareMap;
    case eVoucherTypes.restaurant:
    case eVoucherTypes.restaurants:
      return styles.VoucherImageSquareRestaurant;
    case eVoucherTypes.shop:
    case eVoucherTypes.shops:
      return styles.VoucherImageSquareShop;
    case eVoucherTypes.experience:
    case eVoucherTypes.experiences:
      return styles.VoucherImageSquareExperience;
    case eVoucherTypes.multi:
      return styles.VoucherImageSquareMulti;
  }
  return styles.VoucherImageSquareMap;
}

const companyToLogoUrl = (companyDetails: ICompanyPrediction) => {
  if (companyDetails && companyDetails.assets && companyDetails.assets.length) {
    const logoAsset = companyDetails.assets.find(companyAsset => companyAsset.type === ASSET_TYPE.LOGO);
    if (logoAsset) {
      return logoAsset.asset.sourceLink;
    }
  }
  return null;
}

export const voucherLogo = (product: Partial<IProduct>) => {
  try {
    switch (product.voucherDetails.type) {
      case eVoucherTypes.flightCompanies:
        return flightCompanyToLogoUrl(product.voucherDetails.flightCompanyDetails);
      default:
        return companyToLogoUrl(product.voucherDetails.companyDetails);
    }
  } catch (e) {
    console.log("No logo found", e);
  }
  return null;
}

export const voucherText = (product: Partial<IProduct>) => {
  return getVoucherName(product);
}

const VoucherImageSquare = (props: IVoucherImageSquare) => {
  if (isThereAssetList(props)) {
    return <PlaceImageSquare
      product={props.product}
      gui={props.gui}
      className={`${styles.VoucherImageSquare} ${voucherTypeToImageClass(props.product)} ${props.className}`.trim()}
      iconContainerClassName={`${props.iconContainerClassName} ${styles.iconContainerClassName}`}
      icon={PercentTicket}
      label="שובר"
      logoSrc={voucherLogo(props.product)}
      logoTitle={voucherText(props.product)}
      children={props.children}
    />;
  }

  return (
    <GenericImageSquare
      className={`${styles.VoucherImageSquare} ${voucherTypeToImageClass(props.product)} ${props.className}`.trim()}
      iconContainerClassName={`${props.iconContainerClassName} ${styles.iconContainerClassName}`}
      icon={PercentTicket}
      label="שובר"
      logoSrc={voucherLogo(props.product)}
      logoTitle={voucherText(props.product)}
      children={props.children}
    />
  );
};


VoucherImageSquare.defaultProps = {
  className: '',
  iconContainerClassName: '',
};

export default VoucherImageSquare;
